import { FiXOctagon, FiKey } from "react-icons/fi";
import { formatDateTimeJapanese } from "../../utils/datetime-utils";

function NotificationItem({ notification, onClick }) {
  let leftBorderColor = "border-[#FCBD07]";
  let background = "bg-[#FFFFFF]";
  let hover = "hover:bg-[#F9FAFB]";
  if (notification.type === "judgment_reject") {
    leftBorderColor = "border-[#DA0000]";
  }
  if (notification.status === 1) {
    background = "bg-[#E9F7FD]";
    hover = "hover:bg-[#E9F7F4]";
  }
  const href = "#";
  return (
    <a
      href={href}
      onClick={onClick}
      className={`w-full cursor-pointer border-t border-r border-gray-300 p-0 text-left ${background} ${hover}`}
    >
      <div className={"p-2 border-l-2 h-[96px] " + leftBorderColor}>
        <div className="flex h-[66px] p-2">
          <div className="flex-none w-7 flex items-center mr-4">
            {notification.type === "password_reset" && (
              <FiKey size={24} className="text-[#FCBD07]"></FiKey>
            )}
            {notification.type === "judgment_reject" && (
              <FiXOctagon size={24} className="text-[#DA0000]"></FiXOctagon>
            )}
          </div>
          <div className="grow line-clamp-2">
            <p>
              <span className="align-super leading-[20px] break-all">
                {notification.message}
              </span>
            </p>
          </div>
        </div>
        <div className="text-right">
          <p className="text-sm">
            {formatDateTimeJapanese(notification?.created_at)}
          </p>
        </div>
      </div>
    </a>
  );
}

export default NotificationItem;
